"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Molecules = void 0;
/*
 * Copyright (c) 2023 Discover Financial Services
 * Licensed under MIT License. See License.txt in the project root for license information
 */
const node_1 = require("../common/node");
const avatars_1 = require("./avatars");
const standardButtons_1 = require("./standardButtons");
const smallButtons_1 = require("./smallButtons");
const cards_1 = require("./cards");
const chartDonut_1 = require("./chartDonut");
const chartPie_1 = require("./chartPie");
const chartBar_1 = require("./chartBar");
const chartLine_1 = require("./chartLine");
const chartProgress_1 = require("./chartProgress");
const chips_1 = require("./chips");
const spacing_1 = require("./spacing");
const dropdowns_1 = require("./dropdowns");
const images_1 = require("./images");
const modal_1 = require("./modal");
const popovers_1 = require("./popovers");
const sliders_1 = require("./sliders");
const toasts_1 = require("./toasts");
/**
 * The molecules class.
 * @category Molecules
 */
class Molecules extends node_1.Node {
    constructor(parent) {
        super("molecules", parent);
        this.designSystem = parent.getDesignSystem();
        this.avatars = new avatars_1.Avatars(this);
        this.standardButtons = new standardButtons_1.StandardButtons(this);
        this.smallButtons = new smallButtons_1.SmallButtons(this);
        this.standardCards = new cards_1.Cards(this);
        this.chartDonut = new chartDonut_1.ChartDonut(this);
        this.chartPie = new chartPie_1.ChartPie(this);
        this.chartBar = new chartBar_1.ChartBar(this);
        this.chartLine = new chartLine_1.ChartLine(this);
        this.chartProgress = new chartProgress_1.ChartProgress(this);
        this.chips = new chips_1.Chips(this);
        this.spacing = new spacing_1.Spacing(this);
        this.dropdowns = new dropdowns_1.Dropdowns(this);
        this.images = new images_1.Images(this);
        this.modal = new modal_1.Modal(this);
        this.popovers = new popovers_1.Popovers(this);
        this.sliders = new sliders_1.Sliders(this);
        this.toasts = new toasts_1.Toasts(this);
        this.addDependency(this.designSystem.atoms);
    }
    deserialize(obj) {
        if (!obj)
            return;
        super.deserialize(obj);
        this.avatars.deserialize(obj.avatars);
        this.standardButtons.deserialize(obj.standardButtons);
        this.chartDonut.deserialize(obj.chartDonut);
        this.chartPie.deserialize(obj.chartPie);
        this.chartLine.deserialize(obj.chartLine);
        this.chartProgress.deserialize(obj.chartProgress);
        this.chips.deserialize(obj.chips);
        this.spacing.deserialize(obj.spacing);
        this.dropdowns.deserialize(obj.dropdowns);
        this.images.deserialize(obj.images);
        this.modal.deserialize(obj.modal);
        this.popovers.deserialize(obj.popovers);
        this.sliders.deserialize(obj.sliders);
        this.toasts.deserialize(obj.toasts);
    }
    serialize() {
        const obj = {};
        obj.avatars = this.avatars.serialize();
        obj.standardButtons = this.standardButtons.serialize();
        obj.chartDonut = this.chartDonut.serialize();
        obj.chartPie = this.chartPie.serialize();
        obj.chartLine = this.chartLine.serialize();
        obj.chartProgress = this.chartProgress.serialize();
        obj.chips = this.chips.serialize();
        obj.spacing = this.spacing.serialize();
        obj.dropdowns = this.dropdowns.serialize();
        obj.images = this.images.serialize();
        obj.modal = this.modal.serialize();
        obj.popovers = this.popovers.serialize();
        obj.sliders = this.sliders.serialize();
        obj.toasts = this.toasts.serialize();
        return obj;
    }
}
exports.Molecules = Molecules;
